<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="25rem"
  >
    <template v-slot:activator="{ on }">
      <v-list-item v-if="activatorList === true" @click="openHandler">
        <v-list-item-title>
          {{ activatorText }}
        </v-list-item-title>
      </v-list-item>
      <v-btn
        v-show="showActivator"
        v-else
        :x-small="activatorSize === 'x-small'"
        :small="activatorSize === 'small'"
        :large="activatorSize === 'large'"
        :x-large="activatorSize === 'x-large'"
        :icon="activatorText === null"
        :text="text"
        :color="color"
        :disabled="disabled"
        @click="openHandler"
      >
        <v-icon :left="activatorText !== null" :size="activatorIconSize">{{
          activatorIcon
        }}</v-icon>
        <span v-if="activatorText !== null">{{ activatorText }}</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="pa-1">
        <v-row dense no-gutters align="start" justify="end">
          <v-btn small icon text @click="dialog = !dialog">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" @submit.prevent="submit">
          <v-text-field
            v-if="type === 'text'"
            dense
            filled
            ref="input"
            class="no-before"
            v-model="value"
            :label="inputText"
            :rules="[
              v => v !== undefined || `${this.errorMessage}`,
              v => v !== null || `${this.errorMessage}`,
              v => v !== ' ' || `${this.errorMessage}`,
              v => v !== '' || `${this.errorMessage}`
            ]"
            required
          ></v-text-field>
          <j-decimal-input
            v-else-if="type === 'number'"
            ref="input"
            dense
            filled
            :min="0"
            step="1"
            class="no-before"
            v-model="value"
            :label="inputText"
            required
          >
          </j-decimal-input>
          <h2 v-else-if="type === 'confirm'">{{ inputText }}</h2>
        </v-form>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-row align="center" justify="end" dense no-gutters>
          <v-btn
            :disabled="valid === false"
            small
            :color="submitColor"
            @click="submit"
          >
            {{ submitText }}
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Prompt",
  props: {
    type: {
      default: "text"
    },
    text: {
      type: Boolean,
      default: false
    },
    color: {
      default: ""
    },
    submitText: {
      default: "Soumettre"
    },
    submitColor: {
      default: "success"
    },
    activatorList: {
      type: Boolean,
      default: false
    },
    activatorSize: {
      default: "medium"
    },
    activatorIconSize: {
      default: "medium"
    },
    activatorText: {
      default: null
    },
    activatorIcon: {
      default: "fa-plus"
    },
    inputText: {
      default: ""
    },
    errorMessage: {
      default: "Ce champ est requis"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    initialValue: {
      default: null
    },
    showActivator: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dialog: false,
      value: null,
      valid: false
    };
  },
  methods: {
    submit() {
      if (this.type === "confirm") {
        this.$emit("submit", true);
        this.dialog = false;
      } else if (this.valid === true) {
        this.$emit("submit", this.value);
        this.dialog = false;
      }
    },
    openHandler() {
      setTimeout(() => (this.dialog = true), 100);
    }
  },
  watch: {
    dialog(v) {
      if (v === true && this.initialValue !== null) {
        this.value = this.initialValue;
      } else if (v === false) {
        setTimeout(() => (this.value = null), 100);
      } else if (this.type !== "confirm") {
        setTimeout(() => this.$refs.input.focus(), 100);
      }
    }
  }
};
</script>

<style></style>
